<template>
  <div class="select-all-footer">
    <div
      class="footer-cont"
      :style="{width: isClient ? '100%' : ''}"
    >
      <div class="cont-check">
      </div>
      <div class="cont-payload"></div>
      <div class="cont-right">
        <div class="cont-desc">
          <!-- 无底价标源将无法改价，分享用户将展示原价 -->
        </div>
        <div class="cont-checked">
          已选专利 <span>{{ selectCount }}</span> 个
        </div>
        <div
          v-if="!hideExportBtn"
          class="btn-export"
          @click="openExportSettingDialog"
        >
          导出Excel
        </div>
        <div
          class="btn-nextStep"
          @click="handlePriceChange"
        >
          改价分享
        </div>
        <div
          v-if="partnerType==2"
          class="btn-nextStep"
          @click="toMakePicture()"
        >
          制作图片
        </div>
        <div
          class="btn-export"
          style="margin-right: 0;"
          @click="initHomeStoreState"
        >
          清空已选
        </div>
      </div>
    </div>
    <!-- 扫码改价分享 -->
    <change-price-to-share
      :show-dialog.sync="sharePriceVisible"
      :multi-brand="selectedBrandList"
      @closeShare="handleCloseShareDialog"
    ></change-price-to-share>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import * as type from '@/store/mutation-types';
import changePriceToShare from '@/components/changePriceToShare';
import { exportBrandSourceCell } from '@/apis/home/patentList';
import { clickRecord } from "@/apis/home/homePage";

/**
 * 底部分享组件
 */
export default {
  components: {
    changePriceToShare,
  },
  data() {
    return {
      allChecked: false,
      sharePriceVisible: false,
      selectedBrandList: [],
      disabledBtn: false,
    }
  },
  computed: {
    ...mapState('home', {
      selectCount: state => state.selectCount,
      selectBrandArr: state => state.selectBrandArr,
      allSelect: state => state.allSelect,
      hideExportBtn: state => state.hideExportBtn
    }),
    ...mapState('common', {
      niceList: state => state.niceList,
      allCheckStatus: state => state.allCheckStatus
    }),
    ...mapState('userInfo', {
      userInfo: state => state.QDS_LOGIN_INFO_OFFICE,
      agentInfo: state => state.agentInfo,
      agentType: state => state.agentType,
      partnerType: state => state.partnerType,
      payStatus: state => state.payStatus,
      interiorStatus: state => state.interiorStatus,
      accountType: state => state.accountType,
      builtinType: state => state.builtinType,
      rolePermissionList: state => state.rolePermissionList,
      isClient: state => state.isClient
    }),
  },
  watch: {
    allCheckStatus(val) {
      this.allChecked = val;
    },
  },
  methods: {
    saveClickRecord(projectCode,projectName,remark){
      if(!this.userInfo.userId){return}
      var params = {
        userIdStr: this.userInfo.userId || '0',
        projectCode: projectCode,
        projectName: projectName,
        requestUlr: '/sourceadmin/clickRecord',
        platform: 1,
        remark: remark || ''
      }
      clickRecord(params).then(res=>{
      })
    },
    // 打开导出配置弹窗
    openExportSettingDialog(){
      if (this.selectBrandArr.length == 0) {
        this.$toast.showToast('请选择专利后点击');
        return;
      }
      if (this.selectBrandArr.length > 600) {
        this.$toast.showToast('最多选择600个专利');
        return;
      }
      this.exportExcel();
    },
    exportExcel(){
      var that = this;
      console.log(this.selectBrandArr);
      let esIds = [];
      this.selectBrandArr.forEach(item=>{
        esIds.push(item.id);
      })
      this.$notify({
        title: "数据处理中",
        message: "即将下载...",
        type: "success"
      });
      this.disabledBtn = true;
      let params = {
        esIds: esIds,
      }
      this.handleLastedSelectBrandInfo();
      this.saveClickRecord(50032, 'PC导出excel');
      exportBrandSourceCell(params).then(res=>{
        that.disabledBtn = false
        if(res.code=='00000'){
          sessionStorage.removeItem('lastedSelectPatentInfo_'+document.domain);
          if(res.data){
            location.href = `https://files.quandashi.com/${res.data}`;
          }
        } else{
          that.$toast.showToast(res.msg);
        }
      })
    },
    initHomeStoreState() {
      this.$store.commit(`home/${type.SET_BATCH_SHARE}`, false);
      this.$store.commit(`home/${type.SET_SELECT_COUNT}`, 0);
      this.$store.commit(`home/${type.SET_ALL_SELECT}`, false);
      this.$store.commit(`home/${type.SET_SELECTED_BRAND_ARR}`, []);
      // this.$store.commit(`common/${type.SET_CHECK_ALL_FLAG}`, false);
      sessionStorage.removeItem('lastedSelectPatentInfo_'+document.domain);
    },
    handleLastedSelectBrandInfo(){
      let lastedSelectBrandInfo = {};
      if(this.selectBrandArr && this.selectBrandArr.length > 0){
        lastedSelectBrandInfo = {
          SET_SELECTED_BRAND_ARR: this.selectBrandArr,
          lastedUserIdStr: this.userInfo.userId
        }
      }
      sessionStorage.setItem('lastedSelectPatentInfo_'+document.domain, JSON.stringify(lastedSelectBrandInfo));
    },
    // 改价分享按钮点击
    handlePriceChange() {
      if (this.selectBrandArr.length == 0) {
        this.$toast.showToast('请选择要改价的专利');
        return;
      }
      if (this.selectBrandArr.length > 600) {
        this.$toast.showToast('最多选择600个专利');
        return;
      }
      this.sharePriceVisible = true;
      this.selectedBrandList = cloneDeep(this.selectBrandArr);
      this.handleLastedSelectBrandInfo();

    },
    // 关闭改价分享弹窗
    handleCloseShareDialog() {
      this.sharePriceVisible = false;
    },
    toMakePicture(){
      if (this.selectBrandArr.length == 0) {
        this.$toast.showToast('请选择要制作图片的专利');
        return;
      }
      if (this.selectBrandArr.length > 100) {
        this.$toast.showToast('亲~制作图片最多支持100件专利哟，请调整后再试试~',3000);
        return;
      }
      
      this.handleLastedSelectBrandInfo();
      if(this.isClient && window.navigator.userAgent.indexOf('Electron') < 0){
        this.$router.push({path: "/nineGridShare", query: {fromPath: this.isClient==1 ? 'qdsClient' : 'PC'}})
      } else {
        let nineGridPage = `${location.protocol}//${location.host}/nineGridShare?fromPath=${this.isClient==1 ? 'qdsClient' : 'PC'}`;
        window.open(nineGridPage);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  .select-all-footer {
    position: fixed;
    width: 100vw;
    left: 0;
    bottom: 0;
    height: 80px;
    z-index: 999;
    border-top: 1px solid #e2e3e8;
    background-color: #fff;
    padding: 0;
    box-sizing: border-box;
    .footer-cont {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;
      max-width: 1240px;
      height: 36px;
      margin: 0 auto;
      transform: translateY(22px);
      padding: 0;
      box-sizing: border-box;
      .cont-check {
          color: #222;
          font-size: $font-size-medium;
      }
      .cont-payload {
        flex: 1;
      }
      .cont-right {
        display: flex;
        flex-direction: row;
        align-items: center;
        .cont-desc {
          padding-left: 20px;
          color: #999;
          background: url('../assets/images/footer/icon-warning.png') no-repeat 0 center;
          background-size: 12px;
          font-size: $font-size-medium;
          margin-right: 20px;
        }
        .cont-checked {
          color: #222;
          font-size: $font-size-medium;
          padding-bottom: 4px;
          margin-right: 20px;
          span {
            color: $color-text;
            font-size: $font-size-large-x;
          }
        }
        .btn-export {
          width: 140px;
          height: 36px;
          line-height: 36px;
          font-size: 15px;
          border-radius: 0;
          background: #fff;
          border: 1px solid #FF9400;
          color: #FF9400;
          cursor: pointer;
          margin-right: 20px;
        }
        .btn-nextStep {
          width: 140px;
          height: 36px;
          line-height: 36px;
          font-size: 15px;
          border-radius: 0;
          background: #FF9400;
          border: 1px solid #FF9400;
          color: #fff;
          cursor: pointer;
          margin-right: 20px;
        }
      }
    }
  }
</style>
